import { toAbsoluteUrl } from '@/utils';
import deMessages from './messages/de.json';
import esMessages from './messages/es.json';
import itMessages from './messages/it.json';
import ruMessages from './messages/ru.json';
import enMessages from './messages/en.json';
import frMessages from './messages/fr.json';
import zhMessages from './messages/zh.json';
import viMessages from './messages/vi.json';
import faMessages from './messages/fa.json';

const I18N_MESSAGES = {
  en: enMessages,
  de: deMessages,
  es: esMessages,
  it: itMessages,
  ru: ruMessages,
  fr: frMessages,
  zh: zhMessages,
  vi: viMessages,
  fa: faMessages,
};

const I18N_CONFIG_KEY = 'i18nConfig';

const I18N_LANGUAGES = [{
  label: 'English',
  code: 'en',
  direction: 'ltr',
  flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  messages: I18N_MESSAGES.en
}, {
  label: 'German',
  code: 'de',
  direction: 'ltr',
  flag: toAbsoluteUrl('/media/flags/germany.svg'),
  messages: I18N_MESSAGES.de
}, {
  label: 'Spanish',
  code: 'es',
  direction: 'ltr',
  flag: toAbsoluteUrl('/media/flags/spain.svg'),
  messages: I18N_MESSAGES.es
}, {
  label: 'Italian',
  code: 'it',
  direction: 'ltr',
  flag: toAbsoluteUrl('/media/flags/italy.svg'),
  messages: I18N_MESSAGES.it
}, {
  label: 'Russian',
  code: 'ru',
  direction: 'ltr',
  flag: toAbsoluteUrl('/media/flags/russia.svg'),
  messages: I18N_MESSAGES.ru
}, {
  label: 'French',
  code: 'fr',
  direction: 'ltr',
  flag: toAbsoluteUrl('/media/flags/france.svg'), 
  messages: I18N_MESSAGES.fr
}, {
  label: 'Chinese',
  code: 'zh',
  direction: 'ltr',
  flag: toAbsoluteUrl('/media/flags/china.svg'),
  messages: I18N_MESSAGES.zh
}, {
  label: 'Vietnamese',
  code: 'vi',
  direction: 'ltr',
  flag: toAbsoluteUrl('/media/flags/vietnam.svg'),
  messages: I18N_MESSAGES.vi
}, {
  label: 'Persian',
  code: 'fa',
  direction: 'rtl',
  flag: toAbsoluteUrl('/media/flags/iran.svg'),
  messages: I18N_MESSAGES.fa
}];

const I18N_DEFAULT_LANGUAGE = I18N_LANGUAGES[0];

export { I18N_CONFIG_KEY, I18N_DEFAULT_LANGUAGE, I18N_LANGUAGES, I18N_MESSAGES };
